/**
 * The single chart palette for both next-gen account summary charts and classic v1 (Charts &
 * Details) charts. Every entry is distinct — do not fork this list per surface.
 */
export const DEFAULT_CHART_COLORS = [
  '#4781BF',
  '#A1BBE5',
  '#E59539',
  '#E8CE8B',
  '#6F5DA8',
  '#CDABDB',
  '#3D9990',
  '#7CCFB4',
  '#4C5FB5',
  '#979ACC',
  '#CC5E69',
  '#EDA19F',
  '#4692B0',
  '#8BD4D6',
  '#E0694F',
  '#F5A482',
  '#549970',
  '#9AD9A4',
  '#9C4174',
  '#B4D6FA',
  '#3D6099',
  '#FFE0BD',
  '#D9B55B',
  '#D4C8FA',
  '#6B477A',
  '#B8E0DC',
  '#147556',
  '#BDC9FF',
  '#5C5F99',
  '#FFD4D9',
  '#994946',
  '#B1D7E5',
  '#1D7578',
  '#FFDAD1',
  '#B85830',
  '#C3E3D0',
  '#257D34',
  '#F2B6D8',
  '#9E465D',
  '#1D4673',
  '#82A3D9',
  '#B06209',
  '#F0DBA8',
  '#3E2E73',
  '#B38FC2',
  '#21665E',
  '#56BA9A',
  '#1C2A6B',
  '#B1B4DE',
  '#801B25',
  '#D98784',
  '#275D73',
  '#6DBFC2',
  '#942A12',
  '#ED8A5F',
  '#2E5C40',
  '#77C785',
  '#630F3F',
  '#E09DAF',
  '#91C0F2',
  '#2E4873',
  '#FFCF99',
  '#B29240',
  '#C0B1F2',
  '#543461',
  '#9BD1CC',
  '#0C573F',
  '#9DADF5',
  '#3A3C6B',
  '#FABBC2',
  '#783937',
  '#97CADE',
  '#0F595C',
  '#FABDAF',
  '#9C441F',
  '#A3D1B5',
  '#1A5924',
  '#E096C0',
  '#632938',
  '#2E6299',
  '#BED0ED',
  '#C77110',
  '#FFF3D4',
  '#54438A',
  '#E5C7F2',
  '#2E8077',
  '#ADE0D0',
  '#324494',
  '#E1E2F5',
  '#992F3A',
  '#FABBB9',
  '#367791',
  '#AEE4E5',
  '#B23E24',
  '#FAC4AC',
  '#3E7D57',
  '#B9EBC2',
  '#802458',
  '#FAD4DE',
  '#D9EBFF'
];

export function getChartColors(size: number, defaultColors: string[] = DEFAULT_CHART_COLORS): string[] {
  const total = Math.max(0, Math.floor(size));
  if (total === 0) {
    return [];
  }

  const palette = defaultColors;
  const result: string[] = [];

  for (let index = 0; index < total; index += 1) {
    const color = palette[index % palette.length];
    result.push(color);
  }

  return result;
}
